import angular from "angular";
import toastr from 'toastr';

angular.module("locations_reservations")

    .controller("LocationsReservationsEditCtrl", ['LoginService', '$scope', '$rootScope', '$controller', '$state', '$stateParams', 'Restangular', '$uibModal', 'modalService', '$compile', 'gridService', '$filter', '$translate', '$q', '$http', 'logService',
        function (LoginService, $scope, $rootScope, $controller, $state, $stateParams, Restangular, $uibModal, modalService, $compile, gridService, $filter, $translate, $q, $http, logService) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("LOCATION_RESERVATION_WRITE");

            $rootScope.title = $filter('translate')('locations_reservations.title');


            Restangular.all('Locations').getList().then(function (locations) {
                $scope.selectLocations = locations;
            });

            Restangular.all('Persons/AllPersons').getList().then(function (persons) {
                $scope.selectPersons = persons;
            });

            Restangular.all('Users').getList({ withoutImages: true }).then(function (users) {
                $scope.selectUsers = users;
                //Valor por defecto Responsable_id, si es nuevo evento
                if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {
                    var defaultUserFilter = users.filter(function (u) { return u.id == parseInt(localStorage.getItem("userId")); });
                    if (defaultUserFilter != null && defaultUserFilter.length > 0) {
                        $scope.location_reservation.requested_id = defaultUserFilter[0].id;
                    }
                }
            });


            //Cargamos datos del evento, si procede. 


            let getEventData = function (eventId) {

                Restangular.one('Events', eventId).get().then(function (event) {

                    var options = { entity_type: "events", inheritable: true };

                    $scope.event = event;

                    logService.debug('Fucking event')
                    logService.debug($scope.event)
                    $scope.event.pigs = [];
                    if ($scope.event.information_groups_values == null) {
                        $scope.event.information_groups_values = [];
                    }
                    Restangular.all('InformationsGroups').getList(options).then(function (informationGroups) {

                        $scope.informationGroups = informationGroups;
                        $scope.informationGroups.forEach(function (pig) {
                            if (pig.configuration != "") pig.configuration = JSON.parse(pig.configuration);
                        });
                        $scope.checkboxSimpleOptions = [
                            { option: null, label: $filter('translate')('informations.all'), checked: true },
                            { option: true, label: $filter('translate')('events.staff.yes'), checked: false },
                            { option: false, label: $filter('translate')('events.staff.no'), checked: false }
                        ];

                        logService.debug("like the feeling cant hodl us")
                        logService.debug($scope.event.information_groups_values)

                        // Lo recorremos para pintarlos correctamente.
                        angular.forEach($scope.event.information_groups_values, function (pig) {
                            var infoFilter = $scope.informationGroups.filter(function (el) { return el.id == pig.information_group_id; });
                            if (infoFilter.length>0) {
                                if (infoFilter[0].type == "checkboxSimple") {
                                    $scope.event.pigs[pig.information_group_id] = pig.value; //(pig.value == "true" || pig.value == true ? true : false);
                                } if (infoFilter[0].type == "datetime") {
                                    $scope.event.pigs[pig.information_group_id] = new Date(pig.value);
                                } else {
                                    $scope.event.pigs[pig.information_group_id] = pig.value;
                                }
                            }
                        });

                        logService.debug("Event pigs")
                        logService.debug($scope.event.pigs)

                        logService.debug("$scope.informationGroups");
                        logService.debug($scope.informationGroups);

                    });

                });
            };

        

            // Information groups heredables 

            $scope.selectStatus = [{
                code: 'pending', name: $filter('translate')('locations_reservations.status_pending')
            },{
                code: 'confirmed', name: $filter('translate')('locations_reservations.status_confirmed')
            },{
                code: 'cancelled', name: $filter('translate')('locations_reservations.status_cancelled')
            },{
                code: 'rejected', name: $filter('translate')('locations_reservations.status_rejected')
            }];
            

        if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {
       
            $rootScope.breadcrumb = [
                { title: $filter('translate')('locations_reservations.title'), url: "locations_reservations.list" },
                { title: $filter('translate')('locations_reservations.title_add') }
            ];
            $scope.location_reservation = {};
            $scope.location_reservation.status = $scope.selectStatus[0];
            $scope.location_reservation.FK_locations_reservations_persons_locations_reservations = [];
        } else {
            $rootScope.breadcrumb = [
                { title: $filter('translate')('locations_reservations.title'), url: "locations_reservations.list" },
                { title: $filter('translate')('locations_reservations.button_edit'), url: "locations_reservations.edit({ id: " + $stateParams.id + " })" },
            ];

            Restangular.one('LocationsReservations', $stateParams.id).get().then(function (results) {
                $scope.location_reservation = results;
                $scope.location_reservation.date_from = new Date($scope.location_reservation.date_from);
                $scope.location_reservation.date_to = new Date($scope.location_reservation.date_to);

                if ($scope.location_reservation.event_id) {
                    getEventData($scope.location_reservation.event_id);
                }
                angular.forEach($scope.selectStatus, function (status) {
                    if ($scope.location_reservation.status == status.code) $scope.location_reservation.status = status;
                })
            });            
        }

                                      
        $scope.save = function (frmLocationReservation) {
            $scope.location_reservation.status = $scope.location_reservation.status.code;
            if (!angular.isUndefined($scope.location_reservation.id)) {
                $scope.location_reservation.put().then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('locations_reservations.edit_success'));
                        $state.go("locations_reservations.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {
                Restangular.all('LocationsReservations').post($scope.location_reservation).then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('locations_reservations.create_success'));
                        $state.go("locations_reservations.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        }

        $scope.checkDelete = function () {
            logService.debug($scope.location_reservation);
            modalService.confirm({
                title: $filter('translate')('locations_reservations.button_delete'),
                message: $filter('translate')('locations_reservations.delete_message') + " " + $scope.location_reservation.FK_locations_reservations_locations.name + "?",
                onAccept: function () {
                    $scope.location_reservation.remove().then(function () {
                        toastr.success($filter('translate')('locations_reservations.delete_success'));
                        $state.go("locations_reservations.list");
                    });
                }
            });
        };

}])

.controller("LocationReservationPersonModalCtrl", ['$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', 'locationReservationPerson','personsGrid', function ($scope, $uibModalInstance, Restangular, modalService, $filter, locationReservationPerson, personsGrid) {
    
    $scope.locationReservationPersonModal = (!angular.isUndefined(locationReservationPerson) ? angular.copy(locationReservationPerson) : {});
    $scope.locationReservationPersonOrigin = (!angular.isUndefined(locationReservationPerson) ? locationReservationPerson : {});    

    if ($scope.locationReservationPersonModal.person_id != null || angular.isUndefined($scope.locationReservationPersonModal.id)) {
        $scope.locationReservationPersonModal.unregistered_person = false;
    } else {
        $scope.locationReservationPersonModal.unregistered_person = true;
    }
    
    $scope.options = {
        searchName: "",
    };

    Restangular.all('Persons/AllPersons').getList($scope.options).then(function (persons) {

        $scope.selectPersons = persons;
        let idxPerson = 0;
        if ($scope.locationReservationPersonModal != null) {
            $scope.selectPersons.forEach(function (person) {
                for (var i = 0; i < personsGrid.length; i++) {                    
                    if (person.id == personsGrid[i].person_id) {
                        $scope.selectPersons.splice(idxPerson, 1);
                        break;
                    }
                }
                if (person.id == $scope.locationReservationPersonModal.person_id) $scope.locationReservationPersonModal.person = person;
                idxPerson++;
            });
        }
    });
    

    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.saveLocationReservationPerson = function () {        
        //Devolvemos el control al principal        
        $uibModalInstance.close({ edited: $scope.locationReservationPersonModal, origin: $scope.locationReservationPersonOrigin });

    };//save


}])

;

